// src/pages/MotorcycleForm/diff.js
const same = (a, b) => Object.is(a, b);

export function diffById(prevArr = [], nextArr = [], keys = []) {
    const prev = new Map((prevArr || []).map((x) => [x?._id, x]));
    const next = new Map((nextArr || []).map((x) => [x?._id, x]));

    const added = [];
    const removed = [];
    const updated = [];

    for (const [id, n] of next.entries()) {
        if (!id || !prev.has(id)) {
            added.push(n);
            continue;
        }
        const p = prev.get(id);

        let changed = false;
        for (const k of keys) {
            if (!same(p?.[k], n?.[k])) {
                changed = true;
                break;
            }
        }
        if (changed) updated.push({ before: p, after: n });
    }

    for (const [id, p] of prev.entries()) {
        if (!id || !next.has(id)) removed.push(p);
    }

    return { added, removed, updated, changed: !!(added.length || removed.length || updated.length) };
}

/**
 * 轻量对象 diff：返回改变的 path 列表（用于 debug / optional UI）
 * 注意：这个不是深度优化版，仅用于少量字段。
 */
export function diffObject(prev, next, path = "", out = []) {
    if (same(prev, next)) return out;

    const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);

    if (!isObj(prev) || !isObj(next)) {
        out.push(path || "<root>");
        return out;
    }

    const keys = new Set([...Object.keys(prev), ...Object.keys(next)]);
    for (const k of keys) {
        diffObject(prev[k], next[k], path ? `${path}.${k}` : k, out);
    }
    return out;
}
